import { styled } from '@mui/styles';
import { DistributiveOmit } from '@mui/types';

interface ToggleProps {
  toggle: boolean;
}

export const Container = styled('section')({
  marginBottom: '24px',
});

export const TopWrapper = styled('div')({
  display: 'flex',
  alignItems: 'start',
});

export const ToggleFilters = styled(
  ({
    toggle,
    ...other
  }: ToggleProps &
    DistributiveOmit<
      React.HTMLAttributes<HTMLDivElement>,
      keyof ToggleProps
    >) => <div {...other} />
)({
  marginRight: '16px',
  padding: '14px',
  paddingTop: '12px',
  paddingBottom: '31px',
  borderRadius: '4px 4px 0px 0px',
  fontWeight: 500,
  fontSize: '14px',
  lineHeight: '16px',
  letterSpacing: '0.08px',
  color: 'rgba(108, 115, 125, 1)',
  background: (props: ToggleProps) =>
    props.toggle ? 'rgba(225, 229, 235, 1)' : 'none',
  userSelect: 'none',
  cursor: 'pointer',

  '& > svg': {
    display: 'inline-block',
    marginLeft: '8px',
    verticalAlign: '-4px',
  },
});

export const ActiveWrapper = styled('span')({
  display: 'inline-block',
  position: 'relative',
  minWidth: '30px',
});

export const Circle = styled('svg')({
  position: 'relative',
  top: '-6px',
  right: '8px',
});

export const SearchWrapper = styled('div')({
  flex: 1,

  '& .x5-MuiFormControl-root': {
    width: '100%',
  },
});

export const ToggleContainer = styled(
  ({
    toggle,
    ...other
  }: ToggleProps &
    DistributiveOmit<
      React.HTMLAttributes<HTMLDivElement>,
      keyof ToggleProps
    >) => <div {...other} />
)({
  display: (props) => (props.toggle ? 'block' : 'none'),
  padding: '16px 24px',
  borderRadius: '0px 4px 4px 4px',
  background: 'rgba(225, 229, 235, 1)',
});

export const InputsWrapper = styled('div')({
  '& > :first-child': {
    display: 'flex',
    gap: '8px',
    flexWrap: 'wrap',

    '& .x5-MuiFormControl-root': {
      width: 'auto',
    },
  },
});

export const ConfirmWrapper = styled('div')({
  marginTop: '28px',

  '& > :first-child': {
    marginRight: '12px',
    color: 'rgba(108, 115, 125, 1)',
  },
});

export const ChipsWrapper = styled('div')({
  marginTop: '8px',
  marginBottom: '24px',
});

export const FilterChip = styled('span')({
  padding: '8px 12px',
  paddingRight: '4px',
  marginRight: '8px',
  borderRadius: '4px',
  background: 'rgba(225, 229, 235, 1)',
  fontWeight: 400,
  fontSize: '14px',
  lineHeight: '16px',
  letterSpacing: '0.08px',
  color: 'rgba(59, 64, 71, 1)',
});
